import React, { useContext } from "react";
import MyCalendar from "../../../Common/Calendar-Scheduler/CalendarScheduler";
import scheduleIcon from "../../../Assets/Images/interview-header-icon.svg";
import darkScheduleIcon from "../../../Assets/Images/interview-header-darkicon.svg";
import { DynamicContext } from "../../../Context/DynamicContext";

function InterviewSchedule() {
  const { isDarkMode, userTimezone } = useContext(DynamicContext);
  const defaultCandidate = {
    candidate: {
      name: "",
      role: "",
    },
  };

  return (
    <div>
      <div className="header-main-container">
        <div className="header-icon-title-container">
          <img
            alt=""
            src={isDarkMode ? darkScheduleIcon : scheduleIcon}
            className="header-title-icon"
          />
          <h2 className="header-container">Interviews</h2>
        </div>
      </div>

      <MyCalendar userTimezone={userTimezone} candidate={defaultCandidate} />
    </div>
  );
}

export default InterviewSchedule;
